export function mvAnimation() {
  const wrapper = document.querySelector('.m-mv__wrapper');
  if (!wrapper) return;

  const textTargets = [
    { selector: '.m-mv__catch', startDelay: 2.0 },
    { selector: '.m-mv__title', startDelay: 3.9 },
    { selector: '.m-mv__company-name', startDelay: 6.2 },
  ];

  textTargets.forEach(({ selector, startDelay }) => {
    const el = wrapper.querySelector(selector);
    if (!el) return;
    const charIndex = { value: 0 };
    processNode(el, startDelay, charIndex);
    el.style.visibility = 'visible';
  });

  scheduleAnimation('.m-mv__cat-footprint', 3.1);
  scheduleAnimation('.m-mv__cat--left', 3.5);
  scheduleAnimation('.m-mv__cat--right', 5.3);
  scheduleAnimation('.m-mv__brand', 5.9);
}

function scheduleAnimation(selector, delaySeconds) {
  const el = document.querySelector(selector);
  if (!el) return;
  setTimeout(() => {
    el.classList.add('is-animated');
  }, delaySeconds * 1000);
}

function processNode(el, baseDelay, charIndex) {
  const nodes = Array.from(el.childNodes);
  el.innerHTML = '';

  nodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent.replace(/^\n\s*/, '').replace(/\n\s*$/, '');
      if (!text.trim()) return;
      const chars = [...text];
      chars.forEach((char) => {
        const wrap = document.createElement('span');
        wrap.className = 'm-mv__char-wrap';
        const inner = document.createElement('span');
        inner.className = 'm-mv__char';
        inner.textContent = char;
        inner.style.animationDelay = `${(baseDelay + charIndex.value * 0.05).toFixed(2)}s`;
        wrap.appendChild(inner);
        el.appendChild(wrap);
        charIndex.value++;
      });
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const cloned = node.cloneNode(true);
      el.appendChild(cloned);
      processNode(cloned, baseDelay, charIndex);
    }
  });
}
